import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalsService } from './core';
import { FullLoaderComponent } from './shared/components/loaders';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, FullLoaderComponent
  ],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'angular-tailwindcss';

  constructor(
    readonly globals: GlobalsService
  ) {
  }
}
